module.exports = __webpack_public_path__ + "img/axa.d6289a38.png";